<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-2">
      {{ $t("af:preliminary.psd2_sync.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("af:preliminary.psd2_sync.subtitle") }}
    </p>

    <LeasingPsd2Field
      class="mt-5"
      :label="$t('af:preliminary.psd2_sync.field.title')"
      :description="$t('af:preliminary.psd2_sync.field.description')"
      :skippable="true"
      :source="PSD2_FIELD_SOURCE.PRELIM"
      @skip="onPsd2Skip"
    >
      <div class="psd2-sync-tooltip has-text-weight-bold is-flex">
        <b-icon icon="exclamation-circle" />
        <span class="ml-2">
          {{ $t("af:preliminary.psd2_sync.field.content.tooltip") }}
        </span>
      </div>

      <div class="is-flex mt-5">
        <b-icon icon="user-lock" class="is-blue-icon" size="is-large" />

        <div class="ml-4 is-flex is-flex-direction-column">
          <span class="has-text-weight-bold">
            {{ $t("af:preliminary.psd2_sync.field.content.security.title") }}
          </span>

          <span>
            {{
              $t("af:preliminary.psd2_sync.field.content.security.description")
            }}
          </span>
        </div>
      </div>
    </LeasingPsd2Field>
  </div>
</template>

<script>
import LeasingPsd2Field from "@/components/psd2/LeasingPsd2Field";
import { PSD2_FIELD_SOURCE } from "@/utils/const";
import { mapMutations } from "vuex";

export default {
  name: "LeasingPrescorePsd2Sync",
  components: {
    LeasingPsd2Field,
  },
  props: {},
  data() {
    return {
      PSD2_FIELD_SOURCE,
    };
  },
  async created() {},
  methods: {
    ...mapMutations({
      previousStep: "leassingPrescore/previousStep",
    }),
    onPsd2Skip() {
      this.previousStep();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/colors.scss";

.psd2-sync-tooltip {
  background-color: var(--gray-200, $grey-lightest);
  padding: 0.5rem;
  border-radius: 10px;
}
</style>
